import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../less/collapsible.less';
import imgCollapsed from '../../images/menu-collapsed.png';
import imgExpanded from '../../images/menu-expanded.png';


class Collapsible extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: props.initCollapsed,
    };
  }

  toggleCollapsed = () => {
    const collapsed = { isCollapsed: !this.state.isCollapsed }

    this.setState(collapsed, () => {
      if (this.props.onChange) {
        this.props.onChange(collapsed);
      }
    });
  }

  render() {
    const arrowImg = this.state.isCollapsed
      ? imgCollapsed
      : imgExpanded

    return (
      <div className="date-filters collapsible">
        <img src={arrowImg} className="collapsed-triangle-icon"/>
        <p className="date-filter-p"
           onClick={this.toggleCollapsed}
           dangerouslySetInnerHTML={{ __html: this.props.title }}>
        </p>
        <div className={this.state.isCollapsed ? 'hide' : ''}>
          { this.props.children }
        </div>
      </div>

    )
  }
}

Collapsible.propTypes = {
  initCollapsed: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
};

Collapsible.defaultProps = {
  initCollapsed: true,
  onChange: () => {
  },
};


export default Collapsible;



// WEBPACK FOOTER //
// ./src/components/common/Collapsible.js